.subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

gz-policy-panel-general-inheritance-table {
  margin-top: -20px;
  margin-bottom: 120px;
}
